import { Modal } from 'antd'
import React from 'react'
import CodeEditorSheet, { codeModalProps } from '@src/components/Common/CodeEditorSheet';
import useMetadataEditor from './useMetadataEditor';

const AppMetadataModal = ({ modalVisible, setModalVisible, handleModalSubmit, appName, metadata }: { modalVisible: boolean, setModalVisible: Function, handleModalSubmit: (appName: string, metadata: object) => void, appName: string, metadata: any }) => {

    const { value, setValue, error, commit } = useMetadataEditor({
        metadata,
        onCommit: (parsed) => {
            handleModalSubmit(appName, parsed);
            setModalVisible(false);
        },
    });

    return (
        <Modal
            {...codeModalProps(`${appName} metadata`)}
            open={modalVisible}
            onOk={commit}
            onCancel={() => setModalVisible(false)}
            okText="Save"
        >
            <CodeEditorSheet
                language="yaml"
                value={value}
                onChange={setValue}
                error={error}
                hint="Leave empty to clear the metadata"
                ariaLabel={`${appName} metadata`}
            />
        </Modal>
    )
}

export default AppMetadataModal;
